import { ChangeDetectorRef, Component, OnInit, OnDestroy, Input } from '@angular/core';
import { AAGoogleMapEvents } from 'src/app/core/events/events';
import { EventsService } from 'src/app/core/services/events.service';
import { PrintModel } from 'src/app/modules/route-planner/models/route-print-model';
import { RoutePlannerPrintService } from 'src/app/modules/route-planner/services/route-planner-print/route-planner-print.service';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';
import { AppRouterDataService } from 'src/app/modules/app-routing/services/app-router-data/app-router-data.service';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';

@Component({
    selector: 'aa-route-print-button',
    templateUrl: './route-print-button.component.html',
    styleUrls: ['./route-print-button.component.scss'],
    standalone: false
})
export class RoutePrintButtonComponent implements OnInit, OnDestroy {
  isDesktop = false;

  @Input() type: AARouterURL;

  constructor(private eventsService: EventsService,
    private cdr: ChangeDetectorRef,
    private appRouterDataService: AppRouterDataService,
    private routePrintService: RoutePlannerPrintService,
    private appUtilityService: AppUtilityService) {

      document.addEventListener('keydown', (event) => {
        if (event.which === 80 && (event.ctrlKey || event.metaKey)) {
          event.stopImmediatePropagation();
          event.preventDefault();
          this.printRoutePlan();
          return false;
        }
      });
      this.isDesktop = this.appUtilityService.isDeviceCheck();
  }

  ngOnInit() {
    this.eventsService.on(AAGoogleMapEvents.UPDATE_MAP, this.onUpdateMap);
  }

  ngOnDestroy(): void {
    this.eventsService.remove(AAGoogleMapEvents.UPDATE_MAP, this.onUpdateMap);
  }

  get printModel(): PrintModel {
    return this.routePrintService.printModel;
  }

  public onUpdateMap = () => {
    this.printModel.ShowPrintModel = true;

    setTimeout(() => {
       this.cdr.detectChanges();
    }, 10);
  }

  public printRoutePlan() {
    if (this.type === AARouterURL.MAP_HOTELS) {
      this.appRouterDataService.updateURL(AARouterURL.MAP_PRINT_PREVIEW);
    } else {
      this.appRouterDataService.updateURL(AARouterURL.PRINT_PREVIEW);
    }
  }

}
